export default __webpack_public_path__ + "a61e2aed3adc8515897936b8d79d6026.svg";